export default __webpack_public_path__ + "static/media/Number_2_selected_dark.8debb178.svg";